import { render, staticRenderFns } from "./ForgotPasswordChooseScenario.vue?vue&type=template&id=6e2cbf3e&"
import script from "./ForgotPasswordChooseScenario.vue?vue&type=script&lang=ts&"
export * from "./ForgotPasswordChooseScenario.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports